// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames/bind";

import uuidv4 from "uuid/v4";
import closeIcon from "../../images/close-icon.png";
import failedIcon from "../../images/failed.png";
import Modal from "../Modal/Modal";
import Paragraph from "../Paragraph/Paragraph";
import styles from "./styles";
import barcode from "../../images/barcode.png";

const data = {
  intro: `The barcode is needed to reliably identify items. In most cases, you can find it 
  on the back cover of books. Books can also have an EAN (or ISBN) number. Books without an 
  EAN, IBSN or barcode cannot be sold.`,
  labelText: [
    {
      label: "Books",
      text: `If you cannot find the barcode on the back of your book, try looking on the first 
    or last page of the book to see if you can find the ISBN instead.`,
    },
  ],
};

const basketNotifyText = "We no longer give an offer on the following items:";

class Input extends Component {
  state = {
    open: false,
  };

  static propTypes = {
    classes: PropTypes.object,
    bottomHelper: PropTypes.bool,
    topHelper: PropTypes.string,
    placeholder: PropTypes.string,
    isIndex: PropTypes.bool,
    value: PropTypes.string,
    name: PropTypes.string,
    onChangeInput: PropTypes.func,
    onPress: PropTypes.func,
    error: PropTypes.string,
    basketNotifyError: PropTypes.string,
    isHomePage: PropTypes.bool,
  };

  static defaultProps = {
    classes: {},
    bottomHelper: false,
    topHelper: null,
    placeholder: null,
    isIndex: false,
    name: null,
    value: "",
    onChangeInput: () => {},
    onPress: () => {},
    error: null,
    basketNotifyError: null,
    isHomePage: false,
  };

  onKeyPress = (event) => {
    if (event.key === "Enter") {
      this.props.onPress();
    }
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  renderModal = (text) => {
    const { classes } = this.props;
    return (
      <Modal open={this.state.open} handleClose={this.handleClose}>
        <div className={classes.modalContainer}>
          <div className={classes.modalTopContainer}>
            <span>{text}</span>
            <div
              role={"button"}
              tabIndex={0}
              onKeyPress={this.handleClose}
              className={classes.modalCloseIconContainer}
              onClick={this.handleClose}
            >
              <img
                className={classes.modalCloseIcon}
                src={closeIcon}
                alt={"close icon"}
              />
            </div>
          </div>
          <div className={classes.modalContent}>
            <Paragraph text={data.intro} />
            {data.labelText.map((el) => (
              <div key={uuidv4()} className={classes.infoContainer}>
                <span className={classes.paragraphLabel}>{el.label}</span>
                <Paragraph text={el.text} />
              </div>
            ))}
          </div>
        </div>
      </Modal>
    );
  };

  render() {
    const {
      classes,
      bottomHelper,
      onChangeInput,
      name,
      topHelper,
      placeholder,
      isIndex,
      onPress,
      value,
      error,
      basketNotifyError,
      isHomePage,
    } = this.props;
    const style = isIndex
      ? classes.inputContainerIndex
      : classes.inputContainer;
    const bottomHelperText = "Where do I find the ISBN number?";

    return (
      <div className={isHomePage ? classes.inputContainerIndexForHome : style}>
        {topHelper && <span className={classes.helper}>{topHelper}</span>}
        <div
          className={classNames(
            "input-group mb-3",
            classes.inputButtonContainer
          )}
        >
          <input
            type={"text"}
            className={classNames("form-control", classes.input)}
            placeholder={placeholder || ""}
            value={value || ""}
            onChange={(e) => onChangeInput(e.currentTarget.value, name)}
            aria-label={"Enter"}
            onKeyPress={this.onKeyPress}
            aria-describedby={"basic-addon2"}
          />
          <img src={barcode} className={classes.barcodeImage} alt={"barcode"} />
          <div className={"input-group-append"}>
            <button
              className={classNames(
                "btn btn-outline-secondary",
                classes.btnPrimary
              )}
              onClick={onPress}
              type={"button"}
            >
              GET PRICE
            </button>
          </div>
        </div>
        {bottomHelper && (
          <button
            onClick={() => this.setState({ open: true })}
            className={classes.buttonBottomHelper}
          >
            <span className={classes.inputHelper}>{bottomHelperText}</span>
          </button>
        )}
        <span className={classes.usbScannerText}>
          (Use a USB scanner for faster processing)
        </span>
        {basketNotifyError && (
          <div className={classes.errorNotifyContainer}>
            <span className={classNames([classes.error, classes.errorText])}>
              {basketNotifyText}
            </span>
            <span className={classes.error}>{basketNotifyError}</span>
          </div>
        )}
        {error && (
          <div className={classes.errorContainer}>
            <span className={classes.error}>{error}</span>
            <img
              src={failedIcon}
              className={classes.failedIcon}
              alt={"failed"}
            />
          </div>
        )}

        {this.renderModal(bottomHelperText)}
      </div>
    );
  }
}

export default withStyles(styles)(Input);
